import { render } from "./LoaderHelper.vue?vue&type=template&id=3b930d80"
import script from "./LoaderHelper.vue?vue&type=script&lang=js"
export * from "./LoaderHelper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__